import { Paths } from '@/app/paths';
import Footer from '@/components/Footer';
import MainLoader from '@/components/Loader';
import useIntl from '@/infrastructure/hooks/useIntl';
import { Button, Paper, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';
import clsx from 'clsx';
import { Suspense, useEffect, useLayoutEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { Outlet, useLocation } from 'react-router-dom';
import { getStoredConsent } from '@/infrastructure/consent/consentManager';

import { FocusProvider } from '@features/Chat/ChatInputContext.tsx';

import Header from '@components/Header';
import PageBody from '@components/PageBody';

import Chat from '../Chat';
import styles from './index.module.css';

function Main() {
  const t = useIntl('main');
  const location = useLocation();
  const isMobile = useMediaQuery(`(max-width: 768px)`);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>();

  useEffect(() => {
    const consent = getStoredConsent();
    if (consent?.categories?.analytics) {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search,
        title: location.pathname
      });
    }
  }, [location]);

  const shouldDrawerBeEnabled =
    isMobile &&
    [
      Paths.Main,
      Paths.AccommodationBookingSuccess,
      Paths.AirTransportBookingSuccess
    ].findIndex(el => location.pathname === el) === -1;

  useLayoutEffect(() => {
    if (shouldDrawerBeEnabled) {
      setIsDrawerOpen(true);
    } else {
      setIsDrawerOpen(false);
    }
  }, [shouldDrawerBeEnabled]);

  return (
    <FocusProvider>
      <Header />
      <PageBody>
        <div className={clsx(styles.container)}>
          <div className={clsx(styles['main'])}>
            <div
              className={clsx(styles.mobileContainer, {
                [styles.drawerOpen]: isDrawerOpen
              })}
            >
              <Chat />
              {isMobile && ( // obaviti chat i results drawer bez footera u jedan relative div i tako kontrolirati drawer s position absolute
                <div
                  className={clsx(styles.resultsDrawer, {
                    [styles.open]: isMobile && isDrawerOpen
                  })}
                >
                  <Paper
                    p={0}
                    onClick={
                      shouldDrawerBeEnabled
                        ? () => setIsDrawerOpen(isDrawerOpen => !isDrawerOpen)
                        : () => {}
                    }
                    className={styles.resultsDrawerHeader}
                    withBorder
                  >
                    <Button w="100%" h="100%" variant="white">
                      {!shouldDrawerBeEnabled
                        ? t('chatWithOurAgent')
                        : isDrawerOpen
                          ? t('closeResults')
                          : t('openResults')}
                    </Button>
                  </Paper>
                  <Suspense fallback={<MainLoader />}>
                    <Outlet />
                  </Suspense>
                </div>
              )}
            </div>
            {isMobile && <Footer />}
          </div>
          {!isMobile && (
            <div className={clsx(styles['results'])}>
              <Suspense fallback={<MainLoader />}>
                <Outlet />
              </Suspense>
            </div>
          )}
        </div>
        <Notifications containerWidth={400} />
      </PageBody>
      {!isMobile && <Footer />}
    </FocusProvider>
  );
}

export default Main;
